import { render, staticRenderFns } from "./UnIssuedTaxInvoiceManage.vue?vue&type=template&id=560cca49&scoped=true&"
import script from "./UnIssuedTaxInvoiceManage.vue?vue&type=script&lang=js&"
export * from "./UnIssuedTaxInvoiceManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560cca49",
  null
  
)

export default component.exports